import { render, staticRenderFns } from "./UserEdit.vue?vue&type=template&id=1cd8fa77"
import script from "./UserEdit.vue?vue&type=script&lang=js"
export * from "./UserEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports